export default {
      id: "oldbootstrap-usage",
      viewBox: "0 0 44 44",
      url: __webpack_public_path__ + "img/icons.e72ac2e3.svg#oldbootstrap",
      toString: function () {
        return this.url;
      }
    }